import { createReducer } from 'redux-starter-kit';
import { setInspectionSummaries, putInspectionSummary } from './inspectionSummaryActions';


/**
 * A selector for an inspection summary in the state.
 * @param {object} state The redux state of the application.
 * @param {number} inspectionCode The id of the inspection.
 */
export const selectInspectionSummary = (state, inspectionCode) => state.via.domain.inspectionSummaries[inspectionCode];


/**
 * A dict object with a property key of: inspectionId and a property value of the inspection summary object.
 * @example { 1: { inspectionCode: 1, externalContextReference: '123', regNumber: 'BYXC01ND', inspectionDateTime: '2019-01-21T08:39:07Z' } }
 */
const initialInspectionSummaryState = {
  // 1: { inspectionCode: 1, externalContextReference: '123', regNumber: 'BYXC01ND', inspectionDateTime: '2019-01-21T08:39:07Z' } }
  // 2: { inspectionCode: 2, externalContextReference: '321', regNumber: 'BYXC03WD', inspectionDateTime: '2019-01-20T11:19:33Z' } }
  // ... etc
};

/**
 * A reducer for managing the global via searches.
 */
export default createReducer(initialInspectionSummaryState, {
  // Puts a single inspection summary into the store.
  [putInspectionSummary]: (state, { payload }) => ({
    ...state,
    [payload.inspectionCode]: payload,
  }),

  // Adds/replaces 1 or more inspection summaries in the store.
  [setInspectionSummaries]: (state, action) => {
    const summaries = action.payload;

    return summaries.reduce((newState, summary) => {
      newState[summary.inspectionCode] = summary; // eslint-disable-line no-param-reassign
      return newState;
    }, { ...state });
  },
});
